import { render, staticRenderFns } from "./CustomToast.vue?vue&type=template&id=595f24dc"
import script from "./CustomToast.vue?vue&type=script&lang=js"
export * from "./CustomToast.vue?vue&type=script&lang=js"
import style0 from "./CustomToast.vue?vue&type=style&index=0&id=595f24dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports